import { trpc, TrpcInputs } from '../../config/trpc';
import { formatForServer } from '../../utils/format-line-item';

type BulkUpdateInput = Exclude<TrpcInputs['bulkUpdateRequestLineItems'], void>;
export type Patch = BulkUpdateInput['patch'];

type UseBulkUpdateParams = {
  requestId: number;
};

export const useBulkUpdateRequestLineItems = ({ requestId }: UseBulkUpdateParams) => {
  const { mutateAsync, isLoading, error } = trpc.bulkUpdateRequestLineItems.useMutation();

  const bulkUpdate = (sourceLineItemId: number, peerIds: number[], patch: Patch) =>
    mutateAsync({
      sourceLineItemId,
      peerIds,
      requestId,
      patch: formatForServer<Patch>(patch),
    });

  return [bulkUpdate, isLoading, error?.message] as const;
};
